<div class="search-input {{classes}}" [class.search-input--clear]="model" [class.search-input--loading]="loading">
  <div class="input-wrap">
    <input
      #myinput
      type="text"
      [(ngModel)]="model"
      (ngModelChange)="modelChange.emit(model)"
      (keyup.enter)="enter.emit()"
      [placeholder]="placeholder"
      [autocomplete]="false"
      (blur)="hasBlur.emit()"
      (focus)="hasFocus.emit()"
      [class.error-field]="error"
      [disabled]="disabled"
      [ngStyle]="{'max-width': maxWidth ? maxWidth : ''}"
      data-1p-ignore
      />
    @if (classes.indexOf('search-input--button') !== -1) {
      <button (click)="enter.emit()"><i class="im-icon im-icon-search"></i></button>
    }
  </div>

  @if (!loading && !disabled) {
    <i class="im-icon im-icon-x-round-filled x" (click)="clear.emit()"></i>
  }
  @if (loading) {
    <app-inline-spinner></app-inline-spinner>
  }
</div>
@if (error) {
  <span class="error-field-display">{{error}}</span>
}